import { container } from '../../../DataDomain';
import { IMpxBiographyResponse } from '../../../entity/interface/iMpxVodResponse';
import { IMpxRepository } from '../../repositories/interfaces/IMpxRepository';
import { DI } from '@intigral/constant/config/DIContainer';

export interface IGetBiographyUseCase {
    execute(feed: string): Promise<IMpxBiographyResponse>;
}

export class GetBiographyUsecase implements IGetBiographyUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get mpxRepository(): IMpxRepository {
        return container.resolve<IMpxRepository>(DI.REPOSITORIES.IMpxRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(feed: string): Promise<IMpxBiographyResponse> {
        return await this.mpxRepository.getBiography(feed);
    }
}
